// src/components/structure/StructureDisplayRow.js
import React from 'react';
import {
  StyledTd,
  StructureTableRow
} from '../../styles/displayStructureStyles';

const StructureDisplayRow = ({
  row,
  columns,
  isCurrent,
  isMobilePortrait,
  palette,
  t,
  levelKey,
  timeKey,
  overallIndex,
  events
}) => {
  if (!row) {
    return null;
  }

  const rowId = row.id || `row-${overallIndex}`;
  const isPreTournamentRow = row.type === 'break' && overallIndex === 0;

  if (row.type === 'break') {
    const breakLabel = isPreTournamentRow
      ? t('structure.preTournamentLabel')
      : t('common.break');

    const eventMessages = (events || []).filter(e => e.rowIndex === overallIndex).map(e => e.message).join(' ／ ');
    const displayBreakText = `${breakLabel}${eventMessages ? ` (${eventMessages})` : ''}`;

    if (isMobilePortrait) {
      return (
        <StructureTableRow key={rowId} $palette={palette} $isCurrent={isCurrent}>
          <StyledTd $palette={palette} $isCurrent={isCurrent} colSpan={2}>{displayBreakText}</StyledTd>
          <StyledTd $palette={palette} $isCurrent={isCurrent}>{isPreTournamentRow ? '-' : (row[timeKey] != null ? String(row[timeKey]) : '-')}</StyledTd>
        </StructureTableRow>
      );
    } else {
      return (
        <StructureTableRow key={rowId} $palette={palette} $isCurrent={isCurrent}>
          <StyledTd $palette={palette} $isCurrent={isCurrent} colSpan={columns.length - 1}>{displayBreakText}</StyledTd>
          <StyledTd $palette={palette} $isCurrent={isCurrent}>{isPreTournamentRow ? '-' : (row[timeKey] != null ? String(row[timeKey]) : '-')}</StyledTd>
        </StructureTableRow>
      );
    }
  }

  if (isMobilePortrait) {
    const otherColumns = columns.filter(
      col => col.label !== levelKey && col.label !== timeKey
    );
    const blindEtcContent = otherColumns.map((col, colIdx) => (
      <React.Fragment key={col.id || col.label}>
        {t(col.label) || col.label}: {row[col.label] != null ? String(row[col.label]) : '-'}
        {colIdx < otherColumns.length - 1 && <br />}
      </React.Fragment>
    ));
    return (
      <StructureTableRow key={rowId} $palette={palette} $isCurrent={isCurrent}>
        <StyledTd $palette={palette} $isCurrent={isCurrent}>{row[levelKey] != null ? String(row[levelKey]) : '-'}</StyledTd>
        <StyledTd $palette={palette} $isCurrent={isCurrent}>{blindEtcContent.length > 0 ? blindEtcContent : '-'}</StyledTd>
        <StyledTd $palette={palette} $isCurrent={isCurrent}>{row[timeKey] != null ? String(row[timeKey]) : '-'}</StyledTd>
      </StructureTableRow>
    );
  } else {
    return (
      <StructureTableRow key={rowId} $palette={palette} $isCurrent={isCurrent}>
        {columns.map((col) => {
          const isTimeCol = col.label === timeKey;
          const content = isPreTournamentRow && isTimeCol
            ? '-'
            : (row[col.label] != null ? String(row[col.label]) : '-');

          return (<StyledTd $palette={palette} $isCurrent={isCurrent} key={col.id || col.label}>{content}</StyledTd>);
        })}
      </StructureTableRow>
    );
  }
};

export default React.memo(StructureDisplayRow);